import React, { useMemo } from 'react';
import styles from './AddressesRow.module.scss';
import DropdownSelect from '../../../../../components/dropdownSelect';
import {
  getDocOptionsSelectStreet,
  getOptionsSelect,
} from '../../lib/getOptionsSelect';
import { getRenderControl } from '../../../../../components/SingleControlCustom/getRenderControl';
import useTransportPermitsMatch from '../../hooks/useTransportPermitsMatch';
import { Form } from 'antd';
import useRequestAddresses from '../../../../../queries/useRequestAddresses';
import useStreetsAvailableQuery from '../../../../../queries/useStreetsAvailableQuery';
import { modeRequest } from '../../../../../constants/modeRequest';
import useHouseAvailableQuery from '../../../../../queries/useHouseAvailableQuery';

const AddressesRow = ({ form, permit, isEdit }) => {
  const match = useTransportPermitsMatch();

  const urlCompanyId = match?.params.companyId
    ? Number(match.params.companyId)
    : null;

  const companyId = permit?.company?.id || urlCompanyId;
  const streetIdValue = form.getFieldValue('streetId');
  const houseIdValue = form.getFieldValue('houseId');
  const addressIdValue = form.getFieldValue('addressId');

  const { data: steets = [], isFetching: isStreetsFetching } =
    useStreetsAvailableQuery(
      { companyId, mode: modeRequest.PERMIT },
      { staleTime: Infinity, enabled: !!companyId }
    );

  const { data: houses = [], isFetching: isHouseFetching } =
    useHouseAvailableQuery(
      {
        companyId,
        mode: modeRequest.PERMIT,
        streetId: isEdit ? permit?.streetId : streetIdValue,
      },
      { staleTime: Infinity, enabled: Boolean(isEdit ? true : streetIdValue) }
    );

  const { data: flats = [], isFetching: isFlatFetching } = useRequestAddresses(
    isEdit ? permit?.houseId : houseIdValue,
    {
      enabled: Boolean(isEdit ? true : houseIdValue),
    }
  );

  const optionsSteets = useMemo(
    () => getDocOptionsSelectStreet(steets),
    [steets]
  );
  const optionsHouses = useMemo(
    () => getOptionsSelect({ data: houses }),
    [houses]
  );
  const optionsFlats = useMemo(
    () => getOptionsSelect({ data: flats, isFlat: true }),
    [flats]
  );

  const handleCangeStreet = () => {
    form.setFieldsValue({
      addressId: null,
      clientId: null,
      houseId: null,
    });
  };

  const handleChangeHouse = () => {
    form.setFieldsValue({
      addressId: null,
      clientId: null,
    });
  };

  const handleChangeAddress = () => {
    form.setFieldsValue({
      clientId: null,
    });
  };

  return (
    <div className={styles.root}>
      <Form.Item label="Улица" style={{ margin: 0, flex: 1 }}>
        {form.getFieldDecorator('streetId', {
          initialValue: isEdit ? permit?.streetId : undefined,
          rules: [
            {
              required: true,
              message: 'Пожалуйста, укажите улицу',
            },
          ],
        })(
          <DropdownSelect
            onChange={handleCangeStreet}
            multiple={false}
            options={optionsSteets}
            renderControl={getRenderControl({
              options: optionsSteets,
              isClear: false,
              value: streetIdValue,
              placeholder: 'Выберите из списка',
              disabled: isStreetsFetching || isEdit,
              loading: isStreetsFetching,
            })}
          />
        )}
      </Form.Item>
      <Form.Item label="Дом" style={{ margin: 0, flex: 1 }}>
        {form.getFieldDecorator('houseId', {
          initialValue: isEdit ? permit?.houseId : undefined,
          rules: [
            {
              required: true,
              message: 'Пожалуйста, укажите дом',
            },
          ],
        })(
          <DropdownSelect
            onChange={handleChangeHouse}
            multiple={false}
            options={optionsHouses}
            renderControl={getRenderControl({
              options: optionsHouses,
              isClear: false,
              value: houseIdValue,
              placeholder: '№',
              disabled: isHouseFetching || !streetIdValue || isEdit,
              loading: isHouseFetching,
            })}
          />
        )}
      </Form.Item>
      <Form.Item label="Помещение" style={{ margin: 0, flex: 1 }}>
        {form.getFieldDecorator('addressId', {
          initialValue: isEdit ? permit?.addressId : undefined,
          rules: [
            {
              required: true,
              message: 'Пожалуйста, укажите помещение',
            },
          ],
        })(
          <DropdownSelect
            onChange={handleChangeAddress}
            multiple={false}
            options={optionsFlats}
            renderControl={getRenderControl({
              options: optionsFlats,
              isClear: false,
              value: addressIdValue,
              placeholder: 'Кв./офис',
              disabled: isFlatFetching || !houseIdValue || isEdit,
              loading: isFlatFetching,
            })}
          />
        )}
      </Form.Item>
    </div>
  );
};

export default AddressesRow;
